import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { toastMessage } from "../../utils/toast";
import { useDispatch } from "react-redux";
import { getLocaleValue } from "../../utils";
import * as jobActions from "../../Redux/Actions/jobs";
import Loader from "react-loader-spinner";
import { onMessageListener } from "../../utils/pushNotification";

import { useTranslation } from "react-i18next";

import { clearSession } from "../../utils/initiate";
import * as jobsActions from "../../Redux/Actions/jobs";

const Checkout = ({ history, match }) => {
  const dispatch = useDispatch();
  const [currentItems, setCurrentItems] = useState([]);
  const [balance, setBalance] = useState(0);
  const [currency, setCurrency] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [errStatus, setErrStatus] = useState(200);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payURL, setPayURL] = useState("");
  const [clickFlag, setClickFlag] = useState(false);
  const { jobID } = match.params;
  const { t } = useTranslation();

  // useEffect(() =>{
  //     handleCheckout();
  // },[])

  // const handleCheckout = () => {
  //     window.location.reload();

  // }

  useEffect(() => {
    setLoading(true);
    // jobActions
    //   .getTransactionSummaryDetail(jobID)
    //   .then((res) => {
    //     if (res?.data) {
    //       const summary = res.data?.summary;
    //       //    setTransactionData(res.data);
    //       // setTotalAmount((res?.data.totalAmount).toFixed(1));
    //       // setBalance((res?.data.totalBalanceAmount).toFixed(1));
    //       setCurrency(res?.data.currency);
    //       const summayData = summary.map(({ amount, summary }) => {
    //         return {
    //           amount: amount.toFixed(1),
    //           summary: getLocaleValue(summary),
    //         };
    //       });
    //       setCurrentItems(summayData);
    //     }
    //     // setLoading(false);
    //   })
    //   .catch((err) => {
    //     toastMessage("error", `Unable to get the transaction summary details `);
    //   });

    jobActions
      .getCheckoutDetail(jobID)
      .then((res) => {
        if (res?.data) {
          setPayURL(res.data.paymentLink);
          setTotalAmount(res.data.totalAmount);
          setCurrency(res.data.currency);
          let summary = res.data?.summary;
          let summaryData = summary.map(({ amount, description }) => {
            return {
              amount: amount,
              summary: getLocaleValue(description),
            };
          });
          setCurrentItems(summaryData);
        }
        setLoading(false);
      })
      .catch((err) => {
        toastMessage("error", `Unable to get the payment link `);
        setButtonLoading(false);
        setLoading(false);
        err?.response?.status === 401 && clearSession(dispatch, history);
      });
    // setLoading(false);
  }, []);

  // const broadcast = new BroadcastChannel("count-channel");
  // broadcast.onmessage = (event) => {
  //   if (
  //     event.data.payload.data.type == "PAYMENT_COMPLETE" ||
  //     event.data.payload.data.type == "PAYMENT_FAILED"
  //   )console.log(event);
  //     // history.push(`/jobs/${jobID}`);
  // };

  onMessageListener()
    .then((payload) => {
      let type = payload.data.type;

      let jobId = payload.data.jobID == "0" ? null : payload.data.jobID;
      if (type == "PAYMENT_SUCCESSFUL") {
        history.push(`/home`);
      } else if (type == "PAYMENT_FAILED") {
        history.push(`/jobs/${jobID}`);
      } else if (type == "PAYMENT_COMPLETE" || type == "PAYMENT_FAILED") {
        history.push(`/jobs/${jobID}`);
      }
    })
    .catch((err) => {
      setErrStatus(err?.response?.status);
    });

  // useEffect(() => {
  //   if (payURL && clickFlag) {
  //     setClickFlag(false);

  //     // setButtonLoading(false);
  //   }
  // }, [payURL, clickFlag]);

  const openPaymentPage = () => {
    setButtonLoading(true);
    window.open(payURL, "_blank");
  };

  return (
    <>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center h-75vh">
          <Loader
            type="ThreeDots"
            color="#2d207d"
            height={40}
            width={40}
            style={{ textAlign: "center" }}
          />
        </div>
      ) : (
        <div>
          <div style={{ textAlign: "center" }}>
            <div>
              <span
                style={{
                  fontSize: "30px",
                  fontWeight: "500",
                  borderBottom: "5px solid #b71c1c",
                  paddingTop: "1%",
                  display: "inline-block",
                  marginBottom: "2%",
                }}
              >
                {getLocaleValue("checkout_title")}
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="col-md-5">
              <div className="card">
                <div className="d-flex mt-2">
                  <div
                    className="col-lg-12 card"
                    style={{ border: "0px solid" }}
                  >
                    <div className="card-body form-group fv-plugins-icon-container mb-0">
                      {/* <div className="d-flex justify-content-between"> */}
                      <div style={{ textAlign: "center" }}>
                        <div>
                          <span
                            className="card-title font-weight-bolder text-dark"
                            style={{ fontSize: "20px" }}
                          >
                            {getLocaleValue("checkout_order_summary")}
                          </span>
                        </div>
                      </div>
                      {/* </div> */}
                      <div className="mt-1 d-flex flex-wrap">
                        <table
                          className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg"
                          style={{ marginBottom: "0px" }}
                        >
                          <tbody>
                            {currentItems.map(({ sno, summary, amount }) => {
                              return (
                                <tr key={sno}>
                                  <td>
                                    <span
                                      className="text-dark-75 font-weight-bolder d-block font-size-lg"
                                      style={{
                                        fontWeight: "500",
                                        fontSize: "20px",
                                      }}
                                    >
                                      {summary}
                                    </span>
                                  </td>
                                  <td></td>

                                  <td>
                                    <span
                                      className="text-dark-75 font-weight-bolder d-block font-size-lg"
                                      style={{
                                        fontWeight: "500",
                                        fontSize: "20px",
                                      }}
                                    >
                                      {amount} {currency}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                            <tr>
                              <td>
                                <span
                                  style={{ fontWeight: 500, fontSize: "20px" }}
                                >
                                  {getLocaleValue("checkout_total")}
                                </span>
                              </td>
                              <td></td>
                              <td>
                                <span
                                  style={{ fontWeight: 500, fontSize: "20px" }}
                                >
                                  {`${totalAmount} ${currency}`}{" "}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        {/* <tr>
                            <td></td>
                          <td> */}
                      </div>
                      {/* <hr class="hr-dashed" /> */}
                      {
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <button
                            className="btn btn-primary d-flex align-items-center"
                            disabled={buttonLoading}
                            onClick={openPaymentPage}
                          >
                            <span
                              style={{
                                fontWeight: 500,
                                fontSize: "15px",
                                padding: "5px",
                              }}
                            >
                              {buttonLoading
                                ? getLocaleValue("payment_processing")
                                : getLocaleValue("checkout_btn")}
                            </span>
                            {buttonLoading && (
                              <Loader
                                type="Oval"
                                color="#fff"
                                height={20}
                                width={20}
                                style={{ marginLeft: "10px" }}
                              />
                            )}
                          </button>
                        </div>
                      }
                      {/* </td>
                          <td></td>
                        </tr> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Checkout;

